export function normalizeCalendarDescription(value) {
    if (value == null) return "";

    let text = String(value);

    const altRepLeak = text.match(/^text\/html[,;].*":([\s\S]*)$/i);
    if (altRepLeak) text = altRepLeak[1];

    text = stripHtml(text);
    text = decodeHtml(text);

    return text.replace(/\u00a0/g, " ").trim();
}

function stripHtml(value) {
    return String(value || "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>\s*<p[^>]*>/gi, "\n")
        .replace(/^<p[^>]*>/i, "")
        .replace(/<\/p>$/i, "")
        .replace(/<[^>]+>/g, "");
}

function decodeHtml(value) {
    return String(value || "")
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))
        .replace(/&#x([0-9a-f]+);/gi, (_, code) => String.fromCharCode(parseInt(code, 16)))
        .replace(/&nbsp;/g, " ")
        .replace(/&amp;/g, "&")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&quot;/g, "\"")
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'");
}
